<template>
  <div id="app">
    <template v-if="layout">
      <component :is="layout">
        <router-view :key="$route.path"/>
      </component>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    layout () {
      if (this.$route.meta.layout === false) {
        return null
      }

      return this.$route.meta.layout || process.env.VUE_APP_DEFAULT_LAYOUT
    }
  }
}
</script>
